export const CANONICAL_BRAND_VOICE_FIELD_ALIASES = Object.freeze([
  'ia_persona',
  'ia_tom',
  'whatsapp_template_padrao',
  'whatsapp_assinatura',
]);

const canonicalBrandVoiceFieldAliases = new Set(
  CANONICAL_BRAND_VOICE_FIELD_ALIASES
);

export const omitCanonicalBrandVoiceFields = settings =>
  Object.fromEntries(
    Object.entries(settings).filter(
      ([field]) => !canonicalBrandVoiceFieldAliases.has(field)
    )
  );
